import React from "react";
import { useSelector } from "react-redux";
import { Grid, Row, Col } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import RecognitionList from "./components/RecognitionsList";
import { useRecognitions } from "./hooks/useRecognitions";
import NotificationSystem from "./components/NotificationSystem";
import { useNotifications } from "./hooks/useNotifications";
import LoadingSpinner from "views/Components/LoadingSpinner";
import "./styles.scss";

const Recognitions = () => {
  const { list, loading, success, error } = useSelector(
    (state) => state.recognitions
  );

  useRecognitions();
  const notificationSystem = useNotifications(success, error);

  return (
    <div className="main-content">
      <NotificationSystem ref={notificationSystem} />
      <Card
        content={
          <div className="honor-wall-page">
            <Grid fluid>
              <Row className="honor-wall-header">
                <Col xs={12} className="text-center">
                  <h1 className="honor-wall-title">RECOGNITIONS</h1>
                </Col>
              </Row>
              <Row className="honor-wall-description-container">
                <Col xs={12}>
                  <div className="description-box">
                    <p>
                      Every CopLine volunteer plays an invaluable role in
                      ensuring that their brothers, sisters, and families are
                      never alone. We are deeply grateful for each and every one
                      of you, as your commitment makes our mission possible. We
                      also want to recognize those who have gone above and
                      beyond, dedicating their time, energy, resources and
                      passion to help CopLine not just survive, but thrive. Your
                      extraordinary efforts inspire us all.
                    </p>
                  </div>
                </Col>
              </Row>

              {loading ? (
                <LoadingSpinner />
              ) : (
                <RecognitionList recognitions={list} />
              )}
            </Grid>
          </div>
        }
      />
    </div>
  );
};

export default Recognitions;
